<button type="button" [class]="buttonClass" (click)="login()">{{ label }}</button>
